import MailchimpList from "./MailchimpList";

export default {
  render(h) {
    return (
      <footer class="bg-accent border-t-4 border-gray-700">
        <div class="container mx-auto px-3 lg:px-6 py-10">
          <div class="flex flex-col lg:flex-row">

            <div class="lg:w-3/12">
              <ul class="text-base text-gray-500 mb-10 lg:mb-0">
                <li>
                  <router-link to={{name: 'CoursesPage'}}>
                    {this.$t('courses')}
                  </router-link>
                </li>
                <li>
                  <router-link to={{name: 'AboutPage'}}>
                    {this.$t('about')}
                  </router-link>
                </li>
                <li>
                  <router-link to={{name: 'HelpPage'}}>
                    {this.$t('help_page.h1')}
                  </router-link>
                </li>
                
              </ul>
            </div>
            <div class="lg:w-1/2">
              <ul class="text-base text-gray-500 mb-10 lg:mb-0">
                <li class="text-white text-2xl font-bold">
                  {this.$t('contact_modal.h1')}
                </li>
                <li class="mb-6">
                  <p class="lg:w-1/2">
                    {this.$t('footer.who_office')}
                  </p>
                </li>
                <li class="mb-6">
                  <a href="tel:+4724139402">
                    {this.$t('footer.telephone')}: +(47 241) 39402
                  </a>
                </li>
                <li>
                  {this.$t('footer.fax')}: +(47 241) 39503
                </li>
              </ul>
            </div>
            <div class="lg:w-2/12 hidden lg:block relative">
            <img src={'/img/logo_'+this.$i18n.locale+'.png'} alt="WHO regional office for Africa" class="h-20"/>
            
            <router-link to={{name: 'WorkShopResources'}}><i class="text-gray-600 mdi mdi-toolbox absolute bottom-0 right-0"></i></router-link>
            </div>
          </div>
        </div>
      </footer>
    )
  },
};
